var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00391 13.7709C2.76474 13.7709 2.56641 13.5726 2.56641 13.3334V1.66675C2.56641 1.42758 2.76474 1.22925 3.00391 1.22925C3.24307 1.22925 3.44141 1.42758 3.44141 1.66675V13.3334C3.44141 13.5726 3.24307 13.7709 3.00391 13.7709Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53724 10.2708H3.00391C2.76474 10.2708 2.56641 10.0724 2.56641 9.83325C2.56641 9.59409 2.76474 9.39575 3.00391 9.39575H9.53724C10.1731 9.39575 10.4706 9.22659 10.5289 9.08075C10.5872 8.93492 10.4997 8.60825 10.0447 8.15909L9.34474 7.45909C9.05891 7.20825 8.88391 6.82909 8.86641 6.40909C8.84891 5.96575 9.02391 5.52825 9.34474 5.20742L10.0447 4.50742C10.4764 4.07575 10.6106 3.72575 10.5464 3.57409C10.4822 3.42242 10.1497 3.27075 9.53724 3.27075H3.00391C2.75891 3.27075 2.56641 3.07242 2.56641 2.83325C2.56641 2.59409 2.76474 2.39575 3.00391 2.39575H9.53724C10.8147 2.39575 11.2231 2.92659 11.3572 3.24159C11.4856 3.55659 11.5731 4.22159 10.6631 5.13159L9.96307 5.83159C9.81724 5.97742 9.73557 6.18159 9.74141 6.38575C9.74724 6.56075 9.81724 6.71825 9.93974 6.82909L10.6631 7.54659C11.5556 8.43909 11.4681 9.10409 11.3397 9.42492C11.2056 9.73409 10.7914 10.2708 9.53724 10.2708Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.f8b26af4cfba9be4be2d418f47cadfd8.svg";
export { ForwardRef as ReactComponent };